import styled from 'styled-components';

export const FormatItem = styled.div`
  margin: 0 10px;
  width: 17%; 
  .central-format-item{
      position: relative;
    top: 17px;
  }

  label {
    display: block;
    margin-bottom: 4px;
  }

  .select-format {
    padding: 7px;
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    width: 100%;
    appearance: none;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0l5 5 5-5z' fill='%23d9d9d9'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 10px 6px;
    font-size: 14px;
    color: #333;
    cursor: pointer;

    &:focus {
      outline: none;
      border-color: #40a9ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }

  .select-format option {
    padding: 4px;
    background-color: #fff;
    color: #333;
    cursor: pointer;
  }

  .select-format option:hover {
    background-color: #e6f7ff; /* Cor de fundo ao passar o mouse */
  }
`;